var _templateObject, _templateObject2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { Inner } from '@finect/tabular-core/Inner';
export const Logo = styled.div.withConfig({
  displayName: "partials__Logo",
  componentId: "sc-1v21jd7-0"
})(["display:flex;height:40px;"]);
export const NavMenuAction = styled.div.withConfig({
  displayName: "partials__NavMenuAction",
  componentId: "sc-1v21jd7-1"
})(["display:none;align-items:center;justify-content:center;width:36px;height:36px;border-radius:", ";margin-right:12px;cursor:pointer;background:rgba(255,255,255,0.1);text-align:center;", ";"], _ref => {
  let {
    theme
  } = _ref;
  return theme.borderRadius;
}, maxMediaQueries.phone(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n  "]))));
export const LinksBar = styled(Inner).withConfig({
  displayName: "partials__LinksBar",
  componentId: "sc-1v21jd7-2"
})(["display:none;height:47px;background-color:", ";white-space:nowrap;overflow-x:auto;margin-top:-2px;a{margin:0 1px;text-rendering:optimizeLegibility;}", ";&::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;"], _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.mainColor;
}, maxMediaQueries.phone(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
export const DefaultAvatar = _ref3 => {
  let {
    size,
    fill,
    nonScaling
  } = _ref3;
  const pathProp = nonScaling ? {
    vectorEffect: 'non-scaling-stroke'
  } : {};
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size || '36',
    height: size || '36',
    viewBox: "0 0 40 40",
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    vectorEffect: nonScaling ? 'non-scaling-stroke' : 'default'
  }, React.createElement("path", {
    fill: fill || '#828e9f',
    stroke: "none",
    d: "M0 0h40v40H0V0z"
  }), React.createElement("path", _extends({
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.8",
    d: "M29.2 30.4v-2.3c0-2.6-2.1-4.6-4.6-4.6h-9.2c-2.6 0-4.6 2.1-4.6 4.6v2.3"
  }, pathProp)), React.createElement("circle", _extends({
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.8",
    cx: "20",
    cy: "14.2",
    r: "4.6"
  }, pathProp)));
};